import Modal from 'react-modal';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import {
  contactInfoRequest,
  webFormatCurrency,
  redeemRewardSearchRequest,
  RootState,
  updateRedeemRewardsPreferenceRequest,
  useraccountDetailsRequest,
} from '@rb-serve-app/core';
import CardDropdown from '../../components/CardDropdown';
import Spinner from '../../components/Spinner';
import SuccessModel from '../../components/SuccessModel';
import CommanModal from '../../components/CommanModal';
import { useRecaptchaToken } from '@rb-serve-app/core';
import { EventType, useAnalytics } from '../../ui/Analytics';

type ProfileEditType = {
  isOpen: boolean;
  closeModal: () => void;
  selectedCard: any;
  setRewardSettingSuccessModal: any;
};

type RewardSettingsFormValues = {
  minAmount: string;
  redemptionType: 'manual' | 'automated';
  emailNotify: boolean;
};

export default function RewardSettingPopup({
  isOpen,
  closeModal,
  selectedCard,
  setRewardSettingSuccessModal,
}: ProfileEditType) {
  const { trackEvent } = useAnalytics();
  const dispatch = useDispatch();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [recaptchaError,setRecaptchaError] = useState(false);
   const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
  const [isUnSavedModalOpen, setIsUnSavedModalOpen] = useState(false);
  const { contactDetails } = useSelector(
    (state: RootState) => state.contactInfo
  );
  const { accountId, customerId, accountDetails } = useSelector(
    (state: RootState) => state.user
  );
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const getRecaptchaToken = useRecaptchaToken();
  const {
    redeemRewardsData,
    redeemRewardSearchData,
    updateRedeemRewardsPreferenceData,
    updateredeemRewardsPreferenceLoding,
    redeemRewardSearchLoading,
    redeemRewardSearchError,
    updateredeemRewardsPreferenceError,
  } = useSelector((state: RootState) => state.redeemRewards);

  const { entries, assets } = contentfulData;
  const [email, setEmail] = useState('');
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  // useEffect(() => {
  //   if (selectedCard) {
  //     dispatch(
  //       contactInfoRequest({
  //         accountId: accountId,
  //         primaryCustomerId: customerId,
  //         customerId: selectedCard?.customerId || customerId,
  //       })
  //     );
  //   }
  // }, [selectedCard]);
  console.log(updateredeemRewardsPreferenceError,"updateredeemRewardsPreferenceError",updateRedeemRewardsPreferenceData)

  useEffect(() => {
    if (updateRedeemRewardsPreferenceData?.statusCode === 200) {
      updateRedeemRewardsSearchRequest();
      setRewardSettingSuccessModal(true);
      closeModal();
    } else if (updateRedeemRewardsPreferenceData?.statusCode === 500) {
      setErrorModalOpen(true);
    }
    else{
    if(updateredeemRewardsPreferenceError){
    if(updateredeemRewardsPreferenceError?.status == "401" || updateredeemRewardsPreferenceError?.status == "400"){
       const errorcode =
          updateredeemRewardsPreferenceError?.status == '400'
            ? 'ERR_401_RECAPTCHA_VAL_ERROR'
            : 'ERR_401_RECAPTCHA_LOW_SCORE';
        setTitle(entries?.rb_error?.recaptchaErrors?.[errorcode]?.title);
        setSubTitle(
          entries?.rb_error?.recaptchaErrors?.[errorcode]?.description);
      
    setErrorModalOpen(true);
    setRecaptchaError(true);
    }else{
      setErrorModalOpen(true);
    }
    }
    }
  }, [updateRedeemRewardsPreferenceData,updateredeemRewardsPreferenceError]);

  // useEffect(() => {
  //   updateRedeemRewardsSearchRequest();
  // }, [selectedCard?.cardNumber, accountDetails]);

  const updateRedeemRewardsSearchRequest = () => {
    const payload = {
      userId: accountDetails?.accountId.replace(/^0+/, ''),
      redemptionType: 'PWR',
      userIdType: 'RANAC',
      cardLastFourDigits: selectedCard?.cardNumber?.slice(-4),
    };
    if (selectedCard?.cardNumber?.slice(-4) && accountDetails?.accountId) {
      dispatch(redeemRewardSearchRequest(payload));
    }
  };

  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors, isDirty },
    reset,
  } = useForm<RewardSettingsFormValues>({
    mode: 'onChange',
    defaultValues: {
      //minAmount: '$10.00',
      // redemptionType: 'manual',
      emailNotify: false,
    },
  });
  const lang = localStorage.getItem('language') || 'en-US';
  const rawValue = watch('minAmount');

  useEffect(() => {
    if (isOpen && redeemRewardSearchData) {
      const minAmount =
        redeemRewardSearchData?.redeemerProfile?.preferences?.minAccountPurchaseThreshold?.toString();
      const redemptionType =
        redeemRewardSearchData?.redeemerProfile?.preferences
          ?.redemptionFrequency || 'OFF';
      const emailNotify =
        redeemRewardSearchData?.redeemerProfile?.preferences?.receiveEmailSw ||
        false;

      reset({
        minAmount: minAmount
          ? webFormatCurrency(Number(minAmount), lang)
          : '$10.00',
        redemptionType,
        emailNotify,
      });

      setSuccessModalOpen(false);
      setEmail(
        redeemRewardSearchData?.redeemerProfile?.preferences?.emailAddress
      );
    }
  }, [isOpen, redeemRewardSearchData, reset]);

  // useEffect(() => {
  //   if (successModalOpen) {
  //     closeModal();
  //   }
  // }, [successModalOpen, closeModal]);

  // useEffect(() => {
  //   if (
  //     contactDetails?.availableCards &&
  //     contactDetails?.availableCards?.length > 0
  //   ) {
  //     setSelectedCard(contactDetails?.availableCards[0]);
  //   }
  // }, [contactDetails?.availableCards]);

  useEffect(() => {
    if (accountId && customerId) {
      if (!accountDetails?.customer?.cardLast4) {
        // dispatch(useraccountDetailsRequest({ accountId, customerId }));
      }
    }
  }, [dispatch, accountId, customerId]);

  // useEffect(() => {
  //   if (successModalOpen) {
  //     const timeout = setTimeout(() => {
  //       setSuccessModalOpen(false);
  //     }, 4000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [successModalOpen]);

  useEffect(() => {
    if (isOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isOpen]);

  const onSubmit = async (data: RewardSettingsFormValues) => {
    const token = await getRecaptchaToken('reward_setting');
    const minimumAmount =
      data?.minAmount && data?.minAmount?.replace(/\$/g, '').trim();
    const cleanedValue = parseFloat(minimumAmount);
    const payloadData = {
      accountId: accountId.replace(/^0+/, ''),
      cardLastFourDigits: selectedCard?.cardNumber.slice(-4),
      redemptionType: 'PWR',
      userIdType: 'RANAC',
      emailAddress:
        redeemRewardSearchData?.redeemerProfile?.preferences?.emailAddress,
      fixedAccountRedemptionAmount:
        redeemRewardSearchData?.redeemerProfile?.preferences
          ?.fixedAccountRedemptionAmount,
      minAccountPurchaseThreshold: cleanedValue ? cleanedValue : 10,
      receiveEmailSw: data?.emailNotify,
      receiveSMSSw:
        redeemRewardSearchData?.redeemerProfile?.preferences?.receiveSMSSw,
      redemptionFrequency: data?.redemptionType,
      smsNumber:
        redeemRewardSearchData?.redeemerProfile?.preferences?.smsNumber,
      recaptchaToken: token,
    };

    dispatch(updateRedeemRewardsPreferenceRequest(payloadData));
  };

  const handelSuccessErrorClose = () => {
    setSuccessModalOpen(false);
    setErrorModalOpen(false);
  };

  const handleClickEvent = (action: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      ['modal reward settings', 'rewards'],
      window.location.href,
      `modal reward settings | ${action}`
    );
  };

  const handelClose = () => {
    handleClickEvent('Close');
    if (isDirty || Object.keys(errors).length > 0) {
      setIsUnSavedModalOpen(true);
    } else {
      closeModal();
    }
  };

  const { rewardsSetting } = entries.rb_rewards_setting;

  return (
    <>
      <Modal
        isOpen={isOpen}
        contentLabel={rewardsSetting?.modalTitle}
        aria={{ labelledby: 'reward-settings-heading' }}
        className="fixed right-0 top-0 bottom-0 w-[100%] md:w-[60%] xl:w-[28%] lg:[60%] md:m-2 md:outline-none"
        overlayClassName="w-full fixed inset-0 xl:inset-0 lg:inset-0 md:inset-y-0 md:inset-x-auto bg-black bg-opacity-50"
        shouldFocusAfterRender={true}
        shouldCloseOnOverlayClick={true}
        role="dialog"
      >
        <div className="h-full w-full rounded-lg bg-white flex flex-col relative">
          {/* Scrollable Content */}

          {(!redeemRewardSearchData?.redeemerProfile?.preferences ||
            redeemRewardSearchLoading) && (
            <div className="absolute top-[50%] left-[50%]">
              <Spinner />
            </div>
          )}

          <div className="flex-1 overflow-auto px-[30px] pb-[120px]">
            {' '}
            {/* Add bottom padding to avoid hiding content behind fixed footer */}
            <div className="flex justify-between items-start pt-[30px]">
              <h1
                id="reward-settings-heading"
                className="text-xl font-semibold text-gray-900"
                aria-label={rewardsSetting?.modalTitle}
              >
                {rewardsSetting?.modalTitle}
              </h1>
              <button
                ref={closeButtonRef}
                onClick={handelClose}
                className="text-black hover:text-black focus:outline-none focus:ring focus:ring-red-300 rounded p-1"
                aria-label="Close Reward Settings"
              >
                ✕
              </button>
            </div>
            {selectedCard && (
              <div className="mt-7">
                <p className="w-full flex justify-between pb-[8px] border-b-[1px] border-[#999999] text-[#1F1F1F] text-[16px] font-[650] leading-[24px] tracking-[-0.051px]">
                  {selectedCard?.nameOnCard +
                    '... ' +
                    selectedCard?.cardNumber?.slice(-4)}
                </p>
              </div>
            )}
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="space-y-6"
              aria-labelledby="reward-settings-heading"
              id="reward-settings-form"
            >
              {/* Minimum Amount */}
              <div>
                <label
                  htmlFor="min-amount"
                  className="block text-[16px] font-[600] mt-8"
                  aria-label={rewardsSetting?.setMinimumAmountOpt}
                >
                  {rewardsSetting?.setMinimumAmountOpt}
                </label>
                <p
                  className="text-[16px] font-[450] mt-4 mb-2"
                  aria-label={rewardsSetting?.cashBackRedeemedEligible}
                >
                  {rewardsSetting?.cashBackRedeemedEligible}
                </p>
                <input
                  id="min-amount"
                  type="text"
                  {...register('minAmount', {
                    validate: (value) => {
                      // Remove all characters except digits, dots, and minus sign
                      const cleaned = value && value?.replace(/\$/g, '').trim();
                      const cleanedValue = parseFloat(cleaned);

                      // Check if parsed value is a valid number and at least 10
                      return (
                        (!isNaN(cleanedValue) && cleanedValue >= 10) ||
                        rewardsSetting?.plzEnterAmountGreaterThan
                      );
                    },
                  })}
                  className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 ${
                    errors.minAmount
                      ? 'border-red-500 focus:ring-red-500'
                      : 'border-gray-300 focus:ring-blue-500'
                  }`}
                />
                {errors.minAmount && (
                  <p
                    className="text-red-600 text-sm mt-1"
                    aria-label={errors.minAmount.message}
                  >
                    {errors.minAmount.message}
                  </p>
                )}
              </div>

              {/* Redemption Type */}
              <fieldset>
                <legend
                  className="text-[16px] text-black font-[600] mb-2"
                  aria-label={rewardsSetting?.redemptionType}
                >
                  {rewardsSetting?.redemptionType}
                </legend>
                <div className="space-y-2">
                  <label className="flex items-center justify-between space-x-3 px-[24px] py-[16px] border-b">
                    <div className="flex flex-col gap-1 w-[98%]">
                      <span
                        className="text-sm text-black font-[500]"
                        aria-label={rewardsSetting?.manualDefault}
                      >
                        {rewardsSetting?.manualDefault}
                      </span>
                      <span
                        className="text-[12px] text-black font-[400]"
                        aria-label={rewardsSetting?.manaualDesc}
                      >
                        {rewardsSetting?.manaualDesc}
                      </span>
                    </div>
                    <div className="w-[2%]">
                      <input
                        type="radio"
                        value="OFF"
                        {...register('redemptionType')}
                        className="h-5 w-5 accent-red-600 border border-gray-300 focus:ring-2 focus:ring-red-500"
                      />
                    </div>
                  </label>
                  <label className="flex items-center justify-between space-x-3 px-[24px] py-[16px] border-b-[1px]">
                    <div className="flex flex-col gap-1 w-[98%]">
                      <span
                        className="text-sm text-black font-[500]"
                        aria-label={rewardsSetting?.automated}
                      >
                        {rewardsSetting?.automated}
                      </span>
                      <span
                        className="text-[12px] text-black font-[400]"
                        aria-label={rewardsSetting?.automatedDescription}
                      >
                        {rewardsSetting?.automatedDescription}
                      </span>
                    </div>
                    <div className="w-[2%]">
                      <input
                        type="radio"
                        value="SNGL"
                        {...register('redemptionType')}
                        className="h-5 w-5 accent-red-600 border border-gray-300 focus:ring-2 focus:ring-red-500"
                      />
                    </div>
                  </label>
                </div>
              </fieldset>

              {/* Rewards Notifications */}
              <div>
                <label
                  htmlFor="email-notify"
                  className="text-[16px] font-[600] block mt-[22px]"
                  aria-label={rewardsSetting?.rewardNotifications}
                >
                  {rewardsSetting?.rewardNotifications}
                </label>
                <Controller
                  name="emailNotify"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <div className="flex items-center justify-between space-x-3 pl-[24px] pr-[0px] py-[16px] border-b">
                      <span
                        className="text-[13px] text-black font-[600] w-[80%]"
                        aria-label={rewardsSetting?.rewardNotificationsDesc}
                      >
                        {rewardsSetting?.rewardNotificationsDesc}
                      </span>
                      <button
                        id="email-notify"
                        type="button"
                        role="switch"
                        aria-checked={value}
                        onClick={() => onChange(!value)}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
                          value ? 'bg-primary-red' : 'bg-gray-300'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform bg-white rounded-full transition ${
                            value ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>
                  )}
                />

                {/* //sngl automatic off manual */}
                <div className="px-[24px] py-[16px] border-b">
                  <p
                    className="mt-3 font-[400] text-black text-[13px]"
                    aria-label={email}
                  >
                    {email?.toLowerCase()}
                  </p>
                  <p
                    className="font-[400] text-[#666] text-[13px]"
                    aria-label={rewardsSetting?.webEmailChange}
                  >
                    {rewardsSetting?.webEmailChange}
                  </p>
                </div>
              </div>
            </form>
          </div>

          <div className="absolute bottom-0 left-0 w-full bg-white border-t border-gray-200 px-[30px] py-4">
            <div className="flex justify-between  gap-4">
              <button
                aria-label={rewardsSetting?.close}
                type="button"
                onClick={handelClose}
                className="px-4 py-2 text-sm font-medium text-primary-red bg-white border border-primary-red hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-red-500 w-full max-h-[48px] h-[48px]"
              >
                {rewardsSetting?.close}
              </button>

              <button
                aria-label={rewardsSetting?.update}
                type="submit"
                onClick={() => handleClickEvent('Update')}
                form="reward-settings-form"
                className={`px-4 py-2 text-sm font-medium text-white w-full max-h-[48px] h-[48px] ${
                  isDirty && Object.keys(errors).length === 0
                    ? 'bg-red-600 hover:bg-red-700 focus:ring-red-400'
                    : 'bg-gray-300 cursor-not-allowed'
                }`}
                disabled={!isDirty || Object.keys(errors).length > 0}
              >
                {updateredeemRewardsPreferenceLoding
                  ? `${rewardsSetting?.updating}...`
                  : `${rewardsSetting?.update}`}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {errorModalOpen && (
        <SuccessModel
          isOpen={errorModalOpen}
          title={recaptchaError? title :rewardsSetting?.webTemporaryUnavailable}
          subTitle={recaptchaError?subTitle: rewardsSetting?.webErrorMsg}
          successIcon={false}
          closeModal={handelSuccessErrorClose}
          errorIcon={false}
        />
      )}
      {/* {successModalOpen && (
        <SuccessModel
          isOpen={successModalOpen}
          title={rewardsSetting?.successMsg}
          subTitle={''}
          successIcon={true}
          closeModal={handelSuccessErrorClose}
          errorIcon={false}
          button={false}
        />
      )} */}
      {(isDirty || Object.keys(errors).length > 0) && (
        <CommanModal
          isOpen={isUnSavedModalOpen}
          jsxContent={
            <>
              <div
                className="mt-[20px] text-lg font-semibold text-center"
                aria-label={rewardsSetting?.webUnsavedChangesTitle}
              >
                {rewardsSetting?.webUnsavedChangesTitle}
              </div>
              <div
                className="mt-[20px]"
                aria-label={rewardsSetting?.webUnsavedChangesDesc}
              >
                {rewardsSetting?.webUnsavedChangesDesc}
              </div>
            </>
          }
          onClose={() => {
            setIsUnSavedModalOpen(false);
          }}
          buttonText={rewardsSetting?.cancel}
          cardStatus={true}
          closeIcon={false}
          extraButtonText={rewardsSetting?.confirmCta}
          onExtraButtonClick={() => {
            closeModal();
            setIsUnSavedModalOpen(false);
          }}
        />
      )}
    </>
  );
}
